import { jsx as _jsx } from "react/jsx-runtime";
import Dotdotdot from 'react-dotdotdot';
import { Box } from "../../../box/src";
import { useMatchBreakpoint } from "../../../theme/src";
export const Title = ({ customPadding, title }) => {
    const isBreakpointMobile = useMatchBreakpoint('s');
    const titleFont = isBreakpointMobile ? 'h2-semibold' : 'h1-semibold';
    return (_jsx(Box, Object.assign({ font: titleFont, width: "100%" }, customPadding, { children: _jsx(Dotdotdot, { clamp: isBreakpointMobile ? 5 : 2, useNativeClamp: true, children: _jsx("span", { title: title, children: title }) }) })));
};
//# sourceMappingURL=Title.js.map